import React, {Component} from 'react';

export default class NoSearchResults extends Component {
  constructor( props ) {
    super( props );
    this._isMounted = false;
    this.state = {
      caption: props.caption === undefined ? 'Search for fields' : props.caption,
      width: props.width === undefined ? 'auto' : props.width
    };
  }

  componentDidMount( ) {
    this._isMounted = true;
  }
  
  componentWillReceiveProps( nextProps ) {
    if( this._isMounted === true ) {
      this.setState( { 
        caption: nextProps.caption === undefined ? 'Search for fields' : nextProps.caption,
        width: nextProps.width === undefined ? 'auto' : nextProps.width
      } );
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getStyles() {
    let styles = {};
    styles.width = this.state.width;
    return styles;
  }

  render() { 
    return (
      <span className="loading" style={this.getStyles()}>
        <i className="icon-fontello-search-3 list-grid-search-icon" />
        <span className="loading-text">
          {this.state.caption}
        </span>
      </span>
    );
  }
}


// WEBPACK FOOTER //
// ./src/presentation/NoSearchResults.js